export default __webpack_public_path__ + "static/media/about-top-pc.2022b6c3.png";